import * as React from 'react';

import { MSKU_HAS_ITEMS_FROM_DIFFERENT_FC_WARNING } from '../../../constants/inventories';
import { IInventoryItem } from '../../../types/inventories';
import { isSameFC } from '../../../utils/inventories';
import { ActionButton, BackButton } from '../../forms';
import { InventoryViewItem, ModalActions, ModalHeader, WarningMessage } from '../../index';

import styles from './MskuDetailsModal.module.scss';

interface IProps {
  name: string;
  skuOptions: IInventoryItem[];
  onClose: () => void;
  showCount?: boolean;
  parent: IInventoryItem;
}

const MSKUDetailsModal: React.FC<IProps> = ({ name, skuOptions, onClose, showCount = true, parent }: IProps) => {
  const hasItemsFromDifferentFc = React.useMemo(() => {
    return !isSameFC(skuOptions);
  }, [skuOptions]);

  return (
    <div className={styles.container}>
      <ModalHeader
        titleClassName={styles.title}
        className={styles.header}
        left={<BackButton className={styles.back} onClick={onClose} />}
      >
        {name}
      </ModalHeader>
      <div className={styles.modalContent}>
        <React.Fragment>
          {hasItemsFromDifferentFc && (
            <WarningMessage mode="error" message={MSKU_HAS_ITEMS_FROM_DIFFERENT_FC_WARNING} />
          )}
          {skuOptions.map((skuOption) => {
            const { fulfillment_center_id: itemFCId, item_id: itemId } = skuOption || {};
            const isItemHighLighted = itemFCId !== parent?.fulfillment_center_id;

            return (
              <InventoryViewItem
                isOutlined
                item={skuOption}
                key={itemId}
                showCount={showCount}
                isHighlighted={isItemHighLighted}
              />
            );
          })}
        </React.Fragment>
      </div>
      <ModalActions className={styles.footer}>
        <ActionButton title="Close" className={styles.button} onClick={onClose} />
      </ModalActions>
    </div>
  );
};

export default MSKUDetailsModal;
